import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2b633f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-detail-ctn" }
const _hoisted_2 = {
  key: 0,
  class: "sj"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "div1" }
const _hoisted_5 = {
  class: "topic",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_6 = { class: "b_n" }
const _hoisted_7 = { class: "liu_lan_liang" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = { style: {"display":"none !important","justify-content":"flex-end","align-items":"flex-start"} }
const _hoisted_10 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 我来运营 ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "空间现状信息", -1))
const _hoisted_15 = { class: "space_status" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "用地权属主体", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "用地面积", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "租售意向", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "建筑面积", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "现状照片", -1))
const _hoisted_25 = {
  key: 0,
  class: "now_img"
}
const _hoisted_26 = ["src", "onError"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src", "onClick"]
const _hoisted_29 = {
  key: 1,
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "经营出让条件", -1))
const _hoisted_31 = {
  key: 0,
  class: "jy_tj"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 1,
  class: "jy_tj",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "地块详情", -1))
const _hoisted_35 = {
  key: 0,
  class: "file_list"
}
const _hoisted_36 = ["src", "onError"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 1,
  class: "file_list",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ie_tit" }, "附件", -1))
const _hoisted_42 = {
  key: 0,
  class: "file_list"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "file_list",
  style: {"height":"80px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_45 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-div" }, [
  /*#__PURE__*/_createElementVNode("span", null, "快速咨询"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_47 = { class: "button-div" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-div" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我来运营"),
  /*#__PURE__*/_createElementVNode("span", null, "(快速申请)")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  class: "no_data"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode("资源找不到了")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("去看看其他资源吧~")

import wx from "weixin-js-sdk"
import { onMounted, ref, watch, onBeforeUnmount, onBeforeMount, onActivated } from "vue"
import { showImagePreview } from "vant"
import router from "@/router"
import { useRoute } from "vue-router"
import Map from "@/layout/mapMain/index.vue"
import appConfig from "@/modules/appConfig"
import { getTokenAPi } from "@/api/login"
import { getModules } from "@/modules/arcgisAPI"
import { authoritiesApi } from "@/api/user" // 获取用户权限
import { Collapse, CollapseItem } from "vant"
import { getDetailApi, applyApi, checkOffResourceShelfApi } from "@/api/resource"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { getUserDetailAPi, dicAPi } from "@/api/login"
import { collectApi, removeCollectApi } from "@/api/projectDemand"
import { setToken, getTokenIn } from "@/utils/cookies"
import commons from "@/utils/commons"
import DataList from "@/api/common"
import { useMapStore } from "@/store/modules/map"

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const route = useRoute()
const anchors = ref([440, Math.round(0.98 * window.innerHeight)])
const height: any = ref(440)
const contentDraggable = ref(false)
const onShelf = ref(true) //资源是否上架
const activeName = ref(["1", "2", "3", "4"])
const shareDialog = ref(false) //分享弹框
const accountList = ref([]) //账户类型
const userDetail = ref() //用户基本信息
const datas: any = ref({
  xj: ""
})
const scShow = ref(true) //收藏按钮权限控制
const applayShow = ref(true) //我要申请按钮权限控制
const videoUrlMap = ref<Record<string, string>>({})
const videoLoadFailedMap = ref<Record<string, boolean>>({})

const buildVideoUrl = (sfid: string) => DataList.UpdtImagePrefix() + sfid
const releaseVideoObjectUrls = () => {
  Object.values(videoUrlMap.value).forEach((url) => URL.revokeObjectURL(url))
  videoUrlMap.value = {}
  videoLoadFailedMap.value = {}
}
const resolveVideoSrc = (item: any) => {
  if (item?.sfid && videoUrlMap.value[item.sfid]) {
    return videoUrlMap.value[item.sfid]
  }
  return buildVideoUrl(item.sfid)
}
const fetchVideoBlobUrl = async (item: any) => {
  const token = getTokenIn()
  const response = await fetch(buildVideoUrl(item.sfid), {
    credentials: "include",
    headers: token
      ? {
          Authorization: `Bearer ${token}`
        }
      : undefined
  })
  if (!response.ok) {
    throw new Error("video fetch failed")
  }
  const blob = await response.blob()
  if (videoUrlMap.value[item.sfid]) {
    URL.revokeObjectURL(videoUrlMap.value[item.sfid])
  }
  videoUrlMap.value[item.sfid] = URL.createObjectURL(blob)
  videoLoadFailedMap.value[item.sfid] = false
}
const prepareVideoObjectUrls = async (items: any[]) => {
  releaseVideoObjectUrls()
  const videoItems = (items || []).filter((item: any) => isVideo(item))
  await Promise.all(
    videoItems.map(async (item: any) => {
      try {
        await fetchVideoBlobUrl(item)
      } catch (error) {
        console.error(error)
        videoLoadFailedMap.value[item.sfid] = true
      }
    })
  )
}
const handleVideoError = async (item: any) => {
  try {
    await fetchVideoBlobUrl(item)
  } catch (error) {
    console.error(error)
    videoLoadFailedMap.value[item.sfid] = true
  }
}
const mapStore = useMapStore()
watch(
  () => mapStore.loading2dFinish,
  (value) => {
    if (value) {
      if (route.query.id) {
        getDtail(route.query.id)
      }
    }
  }
)
const setHeight = () => {
  let aa = height.value - 110
  if (height.value == 440) {
    aa = height.value - 110
  } else if (height.value == Math.round(0.98 * window.innerHeight)) {
    aa = height.value - 110
  }
  return aa
}
const previousScrollTop = ref(0)
const onScroll = (e: any) => {
  const scrollTop = e.target.scrollTop
  if (scrollTop > previousScrollTop.value) {
    // 向下滚动
    console.log("向下滚动")
    contentDraggable.value = true
    // 弹框高度设置最高
    height.value = Math.round(0.98 * window.innerHeight)
  } else {
    // 向上滚动
    // if (height.value >= 820) {
    //   // 禁止面板内容滚动折叠面板
    //   contentDraggable.value = false
    // }
    // 回滚到最上面则弹框高度设置最低
    setTimeout(() => {
      scrollTop == 0 ? (height.value = 440) : ""
    }, 100)
    console.log("向上滚动########")
    if (startY.value <= 300) {
      contentDraggable.value = true
    } else {
      contentDraggable.value = false
    }
  }
  previousScrollTop.value = scrollTop
}
// 滚动开始的位置
const startY = ref(0)
const ontouchstart = (e: any) => {
  startY.value = e.touches[0].clientY
  console.log(startY.value)
}
const ontouchend = (e: any) => {
  // console.log(e)
}
// 页面关闭传递消息
onBeforeUnmount(() => {
  releaseVideoObjectUrls()
  wx.miniProgram.postMessage({ data: "offResource" })
})
onActivated(() => {
  if (getTokenIn()) {
    getUserDetailAPi().then((res: any) => {
      if (res.code == 200) {
        userDetail.value = res.data
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
  if (appConfig.detailMapView) {
    appConfig.changeView(appConfig.detailMapView)
  }
  if (route.query.id) {
    const view = appConfig.activeView
    if (view && mapStore.loading2dFinish) {
      getDtail(route.query.id)
    }
  }
})
onBeforeMount(() => {
  // 分享打开资源详情页面
  if (route.query?.fromFlag == "isShare") {
    checkOffShelf(route.query.id)
  } else {
    onShelf.value = true
  }
})
onMounted(() => {
  // getAuthorities() //获取用户权限
  if (route.query.id) {
    const view = appConfig.activeView
    if (view && mapStore.loading2dFinish) {
      getDtail(route.query.id)
    }
  }
  // 需要登录
  if (route.query.loginCode) {
    // 根据登录账号获取token
    getTokens(route.query.loginCode)
    // 缓存openid备用
    if (route.query.openId) {
      const openId = route.query.openId
      if (typeof openId === "string") {
        localStorage.setItem("openId", openId)
      } else if (Array.isArray(openId) && openId.length > 0 && typeof openId[0] === "string") {
        localStorage.setItem("openId", openId[0])
      }
    }
  }
  // initGraphic()
  // getUserDetail() //获取用户基本信息
  if (getTokenIn()) {
    getUserDetailAPi().then((res: any) => {
      if (res.code == 200) {
        userDetail.value = res.data
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
  getAllDict() //获取字典
})
// 判断资源是否已下架
const checkOffShelf = async (id: any) => {
  checkOffResourceShelfApi(id).then((res: any) => {
    if (res.code == 200) {
      if (res.data) {
        // 抱歉，此资源已被删除/下架
        onShelf.value = false
      }
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取token
const getTokens = async (datas: any) => {
  showLoadingToast({
    message: "登录中..."
  })
  getTokenAPi(datas, commons.setT026()).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      setToken(res.data)
      localStorage.setItem("token-key", res.data)
      getDtail(route.query.id)
      showNotify({ type: "success", message: "登录成功" })
      router.replace({ path: "/resource/detail", query: { id: route.query.id } })
    } else {
      getDtail(route.query.id)
      router.replace({ path: "/resource/detail", query: { id: route.query.id } })
    }
  })
}
const initGraphic = async (geometry: any) => {
  const view = appConfig.activeView
  if (!view) return
  const [Polygon, Graphic] = await getModules(["esri/geometry/Polygon", "esri/Graphic"])
  const polygon = new Polygon({ rings: geometry.coordinates, spatialReference: appConfig.activeView.spatialReference })
  const symbol = {
    type: "simple-fill",
    color: [227, 139, 79, 0.2],
    outline: {
      color: [0, 255, 255, 1],
      width: 2
    }
  }
  const graphic = new Graphic({ symbol, geometry: polygon })

  view.graphics.add(graphic)
  view.extent = changeExtent(polygon.extent.clone())
  appConfig.setExtent(view.extent.clone())
}

// 获取图片预览地址
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}
// 判断是否为视频类型
const isVideo = (item: any) => {
  if (!item) return false
  // 优先使用可能存在的 MIME 或类型字段
  if (item.fileType && /video/i.test(item.fileType)) return true
  if (item.contentType && /video/i.test(item.contentType)) return true
  // 使用文件名或 sfid 后缀判断
  const name = (item.fileName || item.sfid || "").toString().toLowerCase()
  return /\.(mp4|webm|ogg|mov|avi|mkv)(\?|$)/.test(name)
}
// 现状照片点击预览
const openImagePreview = (images: any, index: number | string) => {
  console.log(images)
  var imgs: any = []
  images.map((element: any) => {
    imgs.push(DataList.UpdtImagePrefix() + element.sfid)
  })
  showImagePreview({
    images: imgs,
    showIndex: true,
    loop: false,
    closeable: true,
    startPosition: Number(index) || 0
  })
}
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("account_type")
  if (res.code == 200) {
    accountList.value = res.data
  }
}
// 获取详情
const getDtail = async (id: any) => {
  showLoadingToast({
    message: "加载中"
  })
  getDetailApi(id).then((res: any) => {
    if (res.code == 200) {
      closeToast()
      datas.value = res.data
      prepareVideoObjectUrls([...(res.data.xzzpDetail || []), ...(res.data.dkxqDetail || [])])
      if (getTokenIn()) {
        getUserDetailAPi().then((res: any) => {
          if (res.code == 200) {
            userDetail.value = res.data
          } else {
            showNotify({ type: "danger", message: res.message })
          }
        })
      }
      const geojson = res.data.geom || res.data.geojson
      wx.miniProgram.postMessage({
        data: {
          isResource: true,
          title: datas.value.zymc,
          id: id,
          img: DataList.UpdtImagePrefix() + datas.value.fmtpDetail?.sfid
        }
      })
      if (geojson) {
        const geometry = JSON.parse(geojson)
        setTimeout(() => {
          initGraphic(geometry)
        }, 100)
      }
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取用户基本信息
const getUserDetail = (secuss: any) => {
  getUserDetailAPi().then((res: any) => {
    if (res.code == 200) {
      userDetail.value = res.data
      secuss()
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 我要申请
const onClickApply = () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      // title: "标题",
      message: "当前服务需要登录并认证之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: route.query.id } })
    })
  } else {
    // 已经登录需要判断账号类型以及是否认证
    getUserDetail(isAuthentication())
  }
}
// 判断是否认证
const isAuthentication = () => {
  var flag = userDetail.value?.authenticationStatus //认证判断的字段
  console.log(flag)
  var type = userDetail.value?.accountType //账号类型
  var checkStatus = userDetail.value?.authenticationDetail?.status
  // 未认证要判断是否
  //   CHECKING("checking","待审核"),
  //  AGREE("agree","已通过"),
  //  DISAGREE("disagree","已驳回");
  if (flag == "uncheck") {
    showConfirmDialog({
      message: "当前服务需要进行认证之后才可以正常使用! 去认证>>",
      confirmButtonText: "确认"
    }).then(() => {
      // 待审核  驳回
      if (checkStatus == "checking" || checkStatus == "disagree") {
        if (type == "personnel") {
          router.push({ path: "/authenticationPerson", query: { flag: "hasDetail" } })
        } else if (type == "enterprise") {
          router.push({ path: "/authenticationCompany", query: { flag: "hasDetail" } })
        }
      } else {
        //未登录情况需要 跳转到个人中心首页
        if (type == "personnel") {
          router.push({ path: "/authenticationPerson" })
        } else if (type == "enterprise") {
          router.push({ path: "/authenticationCompany" })
        }
      }
    })
  } else if (flag == "checked") {
    // 已经认证情况
    var params = {
      resourceSfid: route.query.id,
      // type: datas.value?.isApply == "1" ? "cancel" : "apply"
      type: "apply"
    }
    // showLoadingToast({
    //   message: "加载中"
    // })
    // 需要跳转到申请页面
    router.push({ path: "/applayForm", query: { id: route.query.id } })
    // applyApi(params).then((res: any) => {
    //   if (res.code == 200) {
    //     closeToast()
    //     // var text = datas.value?.isApply == "1" ? "取消成功" : "申请成功!请在申请记录中查看结果"
    //     var text = "申请成功!请在申请记录中查看结果"
    //     showNotify({ type: "success", message: text })
    //     getDtail(route.query.id)
    //   } else {
    //     closeToast()
    //     showNotify({ type: "danger", message: res.message })
    //   }
    // })
  }
}
// 收藏与取消收藏
const onClickCollect = async () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      message: "当前服务需要登录并认证之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: route.query.id } })
    })
  } else {
    // 已经登录进行接口调用
    var newDatasNo = route.query.id
    var newDatasHas = {
      originalSfid: route.query.id,
      type: "resource"
    }
    var params = datas.value.isCollect == "1" ? newDatasNo : newDatasHas
    getUserDetail(setCollect(params))
  }
}
const setCollect = async (params: any) => {
  showLoadingToast({
    message: "加载中"
  })
  var newUrl = datas.value.isCollect == "1" ? removeCollectApi : collectApi
  newUrl(params).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      closeToast()
      var text = datas.value?.isCollect == "1" ? "取消成功" : "收藏成功!请前往我的收藏查看"
      showNotify({ type: "success", message: text })
      getDtail(route.query.id)
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
const getAuthorities = () => {
  authoritiesApi().then((res: any) => {
    if (res.code == 200) {
      res.data.map((item: any) => {
        if (item.perms == "detailsc" || item.name == "资源详情-收藏") {
          scShow.value = true
        } else if (item.perms == "detailapplay" || item.name == "资源详情-我要申请") {
          applayShow.value = true
        }
      })
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}

// 扩展面范围
const changeExtent = (extent: any) => {
  const x = extent.xmax - extent.xmin
  const y = extent.ymax - extent.ymin
  extent.xmin = extent.xmin - x
  extent.xmax = extent.xmax + x
  extent.ymin = extent.ymin - y
  extent.ymax = extent.ymax + y
  return extent
}

// 客服咨询跳转到壳子
const onService = async () => {
  if (!getTokenIn()) {
    showConfirmDialog({
      message: "当前服务需要登录之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource", resourceId: route.query.id } })
    })
  } else {
    // 已经登录
    wx.miniProgram.redirectTo({
      url: `/pages/webview/webview?kf=${route.query.id}&kfTitle=${datas.value.zymc}&kfImg=${datas.value.fmtpDetail?.sfid}`
    })
  }
}
// 分享
const onShare = async () => {
  shareDialog.value = true
  wx.miniProgram.postMessage({
    data: {
      isResource: true,
      title: datas.value.zymc,
      fromFlag: "isShare",
      id: route.query.id || datas.value.sfid,
      img: DataList.UpdtImagePrefix() + datas.value.fmtpDetail?.sfid
    }
  })
}
const offShareDialog = () => {
  shareDialog.value = false
}
watch(
  () => height,
  (newVal, oldVal) => {
    //回滚
    console.log(newVal.value)
    if (newVal.value == 440) {
      let container: any = document.querySelector(".dialog_content")
      container.scrollTop = 0
    }
    if (newVal.value == Math.round(0.73 * window.innerHeight)) {
      let container: any = document.querySelector(".dialog_content")
      container.scrollTop = 0
    }
  },
  {
    deep: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_P = _resolveComponent("P")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_floating_panel = _resolveComponent("van-floating-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (onShelf.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Map, { style: {"height":"calc(100vh - 440px)"} }),
          _createVNode(_component_van_floating_panel, {
            class: "mianban",
            height: height.value,
            "onUpdate:height": _cache[2] || (_cache[2] = ($event: any) => ((height).value = $event)),
            anchors: anchors.value,
            disableScroll: true,
            "content-draggable": contentDraggable.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['dialog_content', height.value <= 440 ? 'min_dialog_content' : 'max_dialog_content']),
                onScroll: onScroll,
                onTouchstart: ontouchstart,
                onTouchend: ontouchend
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(datas.value.zymc), 1),
                    _createVNode(_component_P, { class: "p_f" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_rate, {
                          modelValue: datas.value.xjNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.value.xjNumber) = $event)),
                          size: 14,
                          color: "#ffd21e",
                          "void-icon": "star",
                          "void-color": "#eee",
                          "allow-half": "",
                          readonly: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(datas.value.browseNum || 0), 1)
                          ])
                        ]),
                        _createElementVNode("i", _hoisted_8, _toDisplayString(datas.value.tdlx), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("span", {
                    onClick: onShare,
                    class: "share_class"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    (scShow.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                          (datas.value?.isCollect == '1')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "off_sc",
                                onClick: onClickCollect
                              }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "sc",
                                onClick: onClickCollect
                              }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (applayShow.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (userDetail.value?.accountType == 'personnel' || userDetail.value?.accountType == 'enterprise')
                            ? (_openBlock(), _createBlock(_component_van_button, {
                                key: 0,
                                color: "#ffcd01",
                                type: "primary",
                                size: "small",
                                onClick: onClickApply,
                                disabled: datas.value.isApply != '0' ? true : false
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(datas.value.isApply == "0" ? "我来运营" : "已申请"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(getTokenIn)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_van_button, {
                            color: "#ffcd01",
                            type: "primary",
                            size: "small",
                            onClick: onClickApply
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(Collapse), {
                  modelValue: activeName.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CollapseItem), {
                      name: "1",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_14
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", null, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(datas.value.ydqsdw || "--"), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_18,
                            _createElementVNode("span", _hoisted_19, _toDisplayString(datas.value.ydmj || 0) + " m²", 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_20,
                            _createElementVNode("span", _hoisted_21, _toDisplayString(datas.value.ndywfy || "--"), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(datas.value.jzmj || 0) + " m²", 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "2",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_24
                      ]),
                      default: _withCtx(() => [
                        (datas.value.xzzpDetail && datas.value.xzzpDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_van_swipe, {
                                class: "swipe-ctn",
                                autoplay: 3000,
                                "indicator-color": "#eeb230"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.xzzpDetail, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: i }, {
                                      default: _withCtx(() => [
                                        (isVideo(item))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (!videoLoadFailedMap.value[item.sfid])
                                                ? (_openBlock(), _createElementBlock("video", {
                                                    key: 0,
                                                    class: "home_img",
                                                    controls: "",
                                                    playsinline: "",
                                                    "webkit-playsinline": "",
                                                    src: resolveVideoSrc(item),
                                                    onError: ($event: any) => (handleVideoError(item)),
                                                    style: {"width":"100%","height":"100%","object-fit":"contain"}
                                                  }, null, 40, _hoisted_26))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "file_name",
                                                    onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName || '视频文件'))
                                                  }, " 视频无法播放，点击下载查看 ", 8, _hoisted_27))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              class: "home_img",
                                              fit: "cover",
                                              src: getImg(item.sfid),
                                              alt: "",
                                              onClick: ($event: any) => (openImagePreview(datas.value.xzzpDetail, i))
                                            }, null, 8, _hoisted_28))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂无照片 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "3",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_30
                      ]),
                      default: _withCtx(() => [
                        (datas.value.jycrtj)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("p", {
                                innerHTML: datas.value.jycrtj
                              }, null, 8, _hoisted_32)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, " 暂无经营出让条件 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "4",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_34
                      ]),
                      default: _withCtx(() => [
                        (datas.value.dkxqDetail && datas.value.dkxqDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.dkxqDetail, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, [
                                  (isVideo(item))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (!videoLoadFailedMap.value[item.sfid])
                                          ? (_openBlock(), _createElementBlock("video", {
                                              key: 0,
                                              controls: "",
                                              playsinline: "",
                                              "webkit-playsinline": "",
                                              src: resolveVideoSrc(item),
                                              onError: ($event: any) => (handleVideoError(item)),
                                              style: {"width":"100%","max-height":"400px","object-fit":"contain"}
                                            }, null, 40, _hoisted_36))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              class: "file_name",
                                              onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName || '视频文件'))
                                            }, " 视频无法播放，点击下载查看 ", 8, _hoisted_37))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        onClick: ($event: any) => (openImagePreview(datas.value.dkxqDetail, i))
                                      }, [
                                        _createElementVNode("img", {
                                          class: "home_img",
                                          fit: "contain",
                                          src: getImg(item.sfid),
                                          alt: "",
                                          style: {"width":"100%"}
                                        }, null, 8, _hoisted_39)
                                      ], 8, _hoisted_38))
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, " 暂无图片 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(CollapseItem), {
                      name: "4",
                      "is-link": false,
                      readonly: ""
                    }, {
                      title: _withCtx(() => [
                        _hoisted_41
                      ]),
                      default: _withCtx(() => [
                        (datas.value.fjDetail && datas.value.fjDetail.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.fjDetail, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName)),
                                  class: "file_name",
                                  key: i + '01'
                                }, _toDisplayString(item.fileName), 9, _hoisted_43))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_44, " 暂无附件 "))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: "footer_third",
                  style: _normalizeStyle({ top: setHeight() + 'px' })
                }, [
                  (scShow.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                        (datas.value?.isCollect == '1')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "off_sc",
                              onClick: onClickCollect
                            }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "sc",
                              onClick: onClickCollect
                            }, _toDisplayString(datas.value.collectNum > 99 ? "99+" : datas.value.collectNum), 1))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_button, {
                    color: "#ffcd01",
                    type: "primary",
                    onClick: onService
                  }, {
                    default: _withCtx(() => [
                      _hoisted_46
                    ]),
                    _: 1
                  }),
                  (applayShow.value && (userDetail.value?.accountType == 'personnel' || userDetail.value?.accountType == 'enterprise'))
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 1,
                        color: "#ffcd01",
                        type: "primary",
                        onClick: onClickApply,
                        disabled: datas.value.isApply != '0' ? true : false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(datas.value.isApply == "0" ? "我来运营" : "已申请"), 1),
                            _createElementVNode("span", null, _toDisplayString(datas.value.isApply == "0" ? "(快速申请)" : ""), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (!_unref(getTokenIn)())
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 2,
                        color: "#ffcd01",
                        type: "primary",
                        onClick: onClickApply
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 4)
              ], 34)
            ]),
            _: 1
          }, 8, ["height", "anchors", "content-draggable"]),
          (shareDialog.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "share_wrap",
                onClick: offShareDialog
              }, _hoisted_50))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _hoisted_52,
          _createVNode(_component_P, null, {
            default: _withCtx(() => [
              _hoisted_53
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})